module.exports = __webpack_public_path__ + "img/Chipsaugen.6742944e.jpg";